import { queryOptions, infiniteQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { communityKeys } from './keys'
import { CACHE_TIMES } from './cache-config'
import { studentCommunityApi } from '@/lib/api/student-community'

export function recentPostsQueryOptions() {
  return queryOptions({
    queryKey: communityKeys.recent(),
    queryFn: async () => {
      const { data, error } = await studentCommunityApi().api.student.community.recent.get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_REALTIME,
  })
}

export function newPostsCountQueryOptions() {
  return queryOptions({
    queryKey: communityKeys.newCount(),
    queryFn: async () => {
      const { data, error } = await studentCommunityApi().api.student.community['new-count'].get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_REALTIME,
  })
}

export function communityChannelsQueryOptions() {
  return queryOptions({
    queryKey: communityKeys.channels(),
    queryFn: async () => {
      const { data, error } = await studentCommunityApi().api.student.community.channels.get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_STATIC,
  })
}

export function channelPostsInfiniteOptions(slug: string) {
  return infiniteQueryOptions({
    queryKey: communityKeys.channelPosts(slug),
    queryFn: async ({ pageParam = 1 }) => {
      const { data, error } = await studentCommunityApi().api.student.community.channels({ slug }).posts.get({
        query: { page: String(pageParam), pageSize: '10' },
      })
      if (error) throw error
      return data
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage: any) => {
      const d = lastPage?.data
      if (d?.hasMore) return d.page + 1
      return undefined
    },
    staleTime: CACHE_TIMES.STALE_REALTIME,
    enabled: !!slug,
  })
}

export function communityThemeQueryOptions() {
  return queryOptions({
    queryKey: [...communityKeys.all(), 'theme'] as const,
    queryFn: async () => {
      const { data, error } = await studentCommunityApi().api.student.community.theme.get()
      if (error) throw error
      return data
    },
    staleTime: Infinity,
  })
}

export function useCreatePost(channelSlug: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: { channelId: string; title: string; description: string; htmlContent: string }) => {
      const { data, error } = await studentCommunityApi().api.student.community.posts.post(body)
      if (error) throw error
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: communityKeys.channelPosts(channelSlug) })
    },
  })
}
